import React from 'react';

const WorkIcon = ({ width = 20, height = 19, fill = '#656263' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.5H20V19.5H0V4.5H6V2.5C6 1.4 6.9 0.5 8 0.5H12C13.1 0.5 14 1.4 14 2.5V4.5ZM8 4.5H12V2.5H8V4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default WorkIcon;
